import { Link, useMatch, useResolvedPath } from "react-router-dom"
import logo from '../media/thetataulogo.png';
import '../App.css';

export default function Navbar() {
  return (
    <nav className="nav" href="#FFFFFF">
      <Link to="/" className="site-title" style={linkStyle1}>
        <img src={logo} className="App-logo" alt="logo" />
        &nbsp;&nbsp;Theta Tau
        <br></br>
        &nbsp;&nbsp;Boston University
      </Link>
      <ul>
        <CustomLink to="/about">About</CustomLink>
        <CustomLink to="/rush">Rush</CustomLink>
        <CustomLink to="/brothers">Brothers</CustomLink>
      </ul>
    </nav>
  )
}

const linkStyle1 = {
  fontFamily: 'Times New Roman',
  //fontSize: 15,
  //fontWeight: 500,
  lineHeight: 1
};

const linkStyle2 = {
  fontFamily: 'Times New Roman'
};

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({ path: resolvedPath.pathname, end: true })

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props} style={linkStyle2}>
        {children}
      </Link>
    </li>
  )
}
